import { mergeStyles } from "@fluentui/react";

export const boldStyle = { root: { fontWeight: 500 } };
export const marginVStyle = { root: { marginTop: 20, marginBottom: 20 } };
export const paddingVStyle = {
  root: { paddingBottom: "1.2rem", paddingTop: "1.2em" },
};

export const gridContentStyle = mergeStyles({
  "@media (min-width: 1740px)": {
    paddingLeft: "5% !important",
    paddingRight: "5% !important",
  },
  "@media (max-width: 1739px)": {
    paddingLeft: "20px !important",
    paddingRight: "20px !important",
  },
});

export const offGridContentStyle = mergeStyles({
  paddingLeft: "10.5px",
  paddingRight: "10.5px",
});

export const skipContentStyle = mergeStyles({
  left: "50%",
  position: "absolute",
  transform: "translateY(-250%)",
  padding: "8px",
  transition: "transform 0.3s",
  backgroundColor: "white",

  "&:focus": {
    transform: "translateY(0%)",
  },
});
